import styled from 'styled-components';
import Button from 'components/Button';

export const Scaffold = styled.section`
  .hidden {
    position: absolute;
    overflow: hidden;
    width: 0;
    height: 0;
    pointer-events: none;
  }

  /* SVG Morph */
  .morph-wrap {
    z-index: -1;
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    width: 100%;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
    pointer-events: none;
  }

  .morph {
    position: relative;
    height: 100%;
    fill: transparent;
    flex: none;
  }

  .content-wrap {
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100vh;
    min-height: 600px;
    pointer-events: none;
  }

  .content {
    position: relative;
    display: grid;
  }

  .content--fixed {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    min-height: 600px;
    z-index: 100;
    pointer-events: none;
    padding: 1.5em;
    grid-template-columns: 50% 50%; 
    grid-template-rows: auto auto 4em;
    grid-template-areas:	"header ..."
                "... decotitle"
                "demos decotitle";
  }

  .content--fixed a {
    pointer-events: auto;
  }

  .content--layout {
    pointer-events: auto;
    justify-content: center;
    align-content: center;
    grid-template-columns: 200px 200px 200px 200px; 
    grid-template-rows: 75px 75px 105px 75px 75px;
    grid-template-areas:	"... ... ... ..."
                "... ... title title"
                "author ... desc desc"
                "author ... link link";
  }

  .content--related {
    height: 0;
  }

  .content__img {
    grid-column: 1 / 4;
    grid-row: 1 / 5;
    opacity: 1;
    width: 350px;
    height: 350px;
  }

  .content__title {
    grid-area: title;
    font-family: 'Poppins', sans-serif;
    font-weight:600;
    font-size: 32px;
    color: #FA4933;
    letter-spacing: -0.2px;
    line-height: 40px;
    z-index: 10;
    cursor: default;
  }

  .content__author {
    grid-area: author;
    margin: 0;
    -webkit-writing-mode: vertical-lr;
    writing-mode: vertical-lr;
    padding: 1em;
    text-align: right;
    z-index: 10;
    cursor: default;
  }

  .content__desc {
    grid-area: desc;
    font-family: 'Poppins', sans-serif;
    font-size: 20px;
    color: #626E75;
    letter-spacing: -0.2px;
    line-height: 28px;
    margin: 0;
    z-index: 10;
    cursor: default;
  }

  .content__img {
    transition: transform 0.3s ease-out;
  }

  .content__link {
    pointer-events: auto;
    grid-area: link;
    align-self: end;
    justify-self: start;
    z-index: 10;
    padding: .8em 1.8em;
  }

  .content__info {
    grid-column: 1 / 3;
  }

  .content__related-item {
    padding: 1em;
    transition: color 0.3s;
  }

  .content__related-img {
    max-width: 100%;
    opacity: 0.8;
    transition: opacity 0.3s;
  }

  .content__related-item:hover .content__related-img,
  .content__related-item:focus .content__related-img {
    opacity: 1;
  }

  .content__related-title {
    font-size: 1em;
    margin: 0;
    padding: 0.5em;
  }

  /* Different layouts */

  /* layout-2 */
  .content--layout-2 {
    grid-template-areas:	"... ... ... ..."
                "title title title ..."
                "desc desc ... author"
                "link link ... author";
  }

  .content--layout-2 .content__img {
    grid-column: 3 / 5;
    grid-row: 1 / 5;
    justify-self: end;
  }

  .content--layout-2 .content__desc {
    text-align: left;
  }

  .content--layout-2 .content__link {
    justify-self: start;
  }

  .content--layout-2 .content__author {
    justify-self: end;
    align-self: start;
  }
`;

export const Footer = styled.div`
  display: block;
`;

export const GetStarted = styled(Button)`
  margin-top: auto;
  grid-area: link;
  max-width: 170px;
`;
